import {Box, List, useTheme, Checkbox, FormControlLabel} from '@mui/material';
import React, {useState} from 'react';
import {useHandoverNoteStyles} from '../../features/notes/handoverNoteStyles';
import {FormikNote, FormikNotesValues, HandoverNoteFields} from './HandoverNotesHelpers';
import {NotesMenuItem} from './NotesMenuItem';
import {useAutoForm} from '../../components/AutoForm/useAutoForm';
import {FeatureBoundary} from '../../contexts/FeatureBoundary';
import {GlobalPermissionEnum} from '../../schema-types/globalTypes';
import {SaltusAny} from '../../utils/SaltusAny';
import {UPDATES} from '../../shared/UPDATES';

export const NotesSideMenu: React.FC<{
  setPage: React.Dispatch<React.SetStateAction<HandoverNoteFields>>;
  currentNotesType: HandoverNoteFields;
  requiredNotes: FormikNote[];
  optionalNotes: FormikNote[];
  onUpdateNote: (noteType: HandoverNoteFields) => SaltusAny;
  readOnly: boolean;
  showTitlesRequiredOptional?: boolean;
  isAtrReadOnly: boolean;
}> = ({
  currentNotesType,
  optionalNotes,
  requiredNotes,
  setPage,
  onUpdateNote,
  readOnly,
  showTitlesRequiredOptional = true,
  isAtrReadOnly,
}) => {
  const classes = useHandoverNoteStyles();
  const theme = useTheme();
  const {setFieldValue} = useAutoForm<FormikNotesValues>();
  const [selectAll, setSelectAll] = useState(false);
  const handleSelectAllChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {checked} = event.target;
    setSelectAll(checked);

    requiredNotes.forEach((note) => {
      setFieldValue(UPDATES._4103, `${note.displayName}.reviewed`, checked, true);
    });

    optionalNotes.forEach((note) => {
      setFieldValue(UPDATES._4103, `${note.displayName}.reviewed`, checked, true);
    });
  };

  return (
    <>
      <Box>
        <FeatureBoundary
          showErrorIfDenied={false}
          features={[GlobalPermissionEnum.can_access_admin_features]}
        >
          <FormControlLabel
            sx={{position: 'absolute', top: 0, right: 0}}
            control={
              <Checkbox
                checked={selectAll}
                onChange={handleSelectAllChange}
                color="primary"
                inputProps={{
                  'aria-label': selectAll ? 'deselect all notes' : 'select all notes',
                }}
              />
            }
            label={selectAll ? 'Deselect All Notes' : 'Select All Notes'}
            style={{marginBottom: theme.spacing(2)}}
          />
        </FeatureBoundary>
        {/* {showTitlesRequiredOptional ? (
          <Typography variant="h5" color="textPrimary">
            Required notes:
          </Typography>
        ) : null} */}

        {/* <Box display="flex" alignItems="flex-end" justifyContent="space-between">
          <div style={{width: doneWidth, textAlign: 'center'}}>Status</div>
          <div
            style={{
              textAlign: 'center',
              fontSize: theme.typography.fontSize * 0.8,
              lineHeight: 1.2,
              width: 55,
            }}
          >
            No
            <br /> changes
          </div>
        </Box> */}
        <List style={{paddingBottom: 0}} data-test="Required Notes">
          {requiredNotes
            .filter((note) => {
              if (!note.isVisible) {
                return false;
              }
              return true;
            })
            .map((note) => {
              const isReadOnly = note.displayName === 'Attitude to risk' && isAtrReadOnly;
              return (
                <NotesMenuItem
                  data-testid="NotesMenuItem"
                  readOnly={readOnly || isReadOnly}
                  onUpdateNote={onUpdateNote}
                  setPage={setPage}
                  key={note.displayName}
                  currentScreen={currentNotesType}
                  menuItemScreen={note.displayName}
                >
                  {note.displayName}
                </NotesMenuItem>
              );
            })}
        </List>
        {/* {optionalNotes.length && showTitlesRequiredOptional ? (
          <Typography
            variant="h5"
            style={{
              marginBottom: theme.spacing(0),
            }}
            color="textPrimary"
          >
            Optional notes:
          </Typography>
        ) : null} */}
        <List style={{paddingTop: 0}} data-test="Optional Notes">
          {optionalNotes.map((note) => {
            const isReadOnly = note.displayName === 'Attitude to risk' && isAtrReadOnly;
            return (
              <NotesMenuItem
                data-testid="NotesMenuItem"
                readOnly={readOnly || isReadOnly}
                onUpdateNote={onUpdateNote}
                setPage={setPage}
                key={note.id}
                currentScreen={currentNotesType}
                menuItemScreen={note.displayName}
              >
                {note.displayName}
              </NotesMenuItem>
            );
          })}
        </List>
      </Box>
    </>
  );
};
